module.exports = __webpack_public_path__ + "img/default_corner.ea811aac.svg";